import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { ITranslation } from '@app/shared/interfaces/common-interfaces';

export interface IManageCertInterface {
  owner: string;
  issued: string; // Timestamp
  validTo: string; // Timestamp
  serial: number;
  commonName: string;
  status: CertStatus;
  email: string;
}

export interface ICertificateData {
  owner: ITranslation;
  remainingCount: number;
  packType: PackType;
  validFrom: number; // Timestamp
  validTo: number; // Timestamp
  serialNo: string;
  alias?: string;
  certReqId: string;
  certId: number;
  commonName: string;
  status: CertStatus;
  statusId?: number;
  email: string;
  deviceIds: string[];
  limit: number;
}

export interface ICertificateDetailsData {
  personalId: string;
  owner: ITranslation;
  email: string;
  issuedOn: number; // Timestamp
  validFrom: number; // Timestamp
  validTo: number; // Timestamp
  serialNo: string;
  serialNumber: string;
  alias?: string;
  status: CertStatus;
  packType: PackType;
  remainingCount: number;
  certReqId: string;
  certId: number;
}

export enum PackType {
  PREPAID = 'PREPAID',
  INFINITE = 'INFINITE'
}

export enum CertStatus {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
  HOLDED = 'HOLDED',
  PENDING_HOLD = 'PENDING_HOLD',
  PENDING_RESTORE = 'PENDING_RESTORE',
  WAITING_ACTIVATION = 'WAITING_ACTIVATION'
}

export enum PersonalIdType {
  PNOBG = 'PNOBG',
  PASXX = 'PASXX',
  IDCXX = 'IDCXX',
  PASYY = 'PASYY'
}

export const statusIcon = {
  VALID: {
    icon: iconCodes.done,
    colorClass: 'text-success',
    tooltip: 'manageTexts.tooltips.statusValid'
  },
  EXPIRED: {
    icon: iconCodes.alarm,
    colorClass: 'text-danger',
    tooltip: 'manageTexts.tooltips.statusExpired'
  },
  REVOKED: {
    icon: iconCodes.blocked,
    colorClass: 'text-danger',
    tooltip: 'manageTexts.tooltips.statusRevoked'
  },
  HOLDED: {
    icon: iconCodes.pan_tool,
    colorClass: 'text-warning',
    tooltip: 'manageTexts.tooltips.statusHolded'
  },
  PENDING_HOLD: {
    icon: iconCodes.hourglass_empty,
    colorClass: 'text-warning',
    tooltip: 'manageTexts.tooltips.statusPendingHold'
  },
  PENDING_RESTORE: {
    icon: iconCodes.hourglass_empty,
    colorClass: 'text-warning',
    tooltip: 'manageTexts.tooltips.statusPendingRestore'
  },
  WAITING_ACTIVATION: {
    icon: iconCodes.hourglass_empty,
    colorClass: 'text-warning',
    tooltip: 'manageTexts.tooltips.statusWaitingActivation'
  }
};

export const statusName = {
  VALID: {
    text: 'manageTexts.statusType.valid'
  },
  EXPIRED: {
    text: 'manageTexts.statusType.expired'
  },
  REVOKED: {
    text: 'manageTexts.statusType.revoked'
  },
  HOLDED: {
    text: 'manageTexts.statusType.holded'
  }
};

export const planName = {
  PREPAID: {
    text: 'prepaid'
  },
  INFINITE: {
    text: 'infinite'
  },
  FREE: {
    text: 'free'
  }
};

export const personalIdType = {
  PNO: {
    text: 'manageTexts.idTypes.egn'
  },
  PAS: {
    text: 'manageTexts.idTypes.passportNumber'
  },
  IDC: {
    text: 'manageTexts.idTypes.identityCardNumber'
  },
  TIN: {
    text: 'manageTexts.idTypes.tin'
  }

};
